var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.header_show)?_c('app-header'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath,on:{"header":_vm.header,"footer":_vm.footer}}),_c('keep-alive',[(_vm.footer_show)?_c('app-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }